import React, { useEffect, useState } from 'react'
import CrumbFeature from '../widgets/CrumbFeature';
import CrumbArrow from '../widgets/CrumbArrow';
import { crumbType_Config, getSelectedOrderedSteps, isAppStep } from '../../hooks/useSelector';
import { useConfigStepsContext } from '../../providers/ConfigStepsContextProvider';
import { getPage } from '../../hooks/useKiponosNavigator';
import { useBreadCrumbsContext } from '../../providers/BreadCrumbsContextProvider';
import './ControlBar.css';


const ControlBarPro = () => {
  const {controlBar} = useBreadCrumbsContext();
  const {configSteps} = useConfigStepsContext();  

  const [featureTitle, setFeatureTitle] = useState('');
  const [orderedCrumbs, setOrderedCrumbs] = useState([]);
  
  useEffect(()=>{
    if (controlBar?.pageKey) {
      // console.log('-------------ControlBar: %s', JSON.stringify(controlBar));    
      const page = getPage(controlBar.pageKey);
      setFeatureTitle(page.title);
    }
  },[controlBar]);


  useEffect(()=>{
    if (configSteps) {
      const ordered = getSelectedOrderedSteps(configSteps)
                      .map(step => <CrumbArrow  key={step}
                                                name={step}
                                                type={crumbType_Config}
                                                isFirst={isAppStep(step)}>
                                                {configSteps[step]}
                                    </CrumbArrow>);
      setOrderedCrumbs(ordered);
    }
  }, [configSteps]);


  return (
    <div className='controlBar'>
      <CrumbFeature>
        {featureTitle}
        {/* {controlBar?.feature} */}
      </CrumbFeature>
      <div style={{display:'flex', flexGrow:1, justifyContent:'flex-start'}}>
        <div className='breads'>
          {orderedCrumbs} 
        </div>      
      </div>
    </div>
  )
}


export default React.memo(ControlBarPro);